import type { PermitFormData, WizardSettings } from "./PermitContextProvider/types";

type ResolveRegistrationInstructionsArgs = {
	baselineInstructions: string | undefined;
	wizardSettings: WizardSettings | undefined;
	formData: Pick<PermitFormData, "parkingChoiceId" | "locationIds">;
};

export const resolveRegistrationInstructions = ({
	baselineInstructions,
	wizardSettings,
	formData,
}: ResolveRegistrationInstructionsArgs): string | undefined => {
	if (baselineInstructions?.trim()) {
		return baselineInstructions;
	}

	const choices = wizardSettings?.choices ?? [];
	const selectedChoice =
		choices.find((choice) => choice.permitTypeId === formData.parkingChoiceId) ??
		(choices.length === 1 ? choices[0] : undefined);
	if (!selectedChoice) {
		return undefined;
	}

	if (selectedChoice.locationChoiceEnabled) {
		const selectedLocationId = formData.locationIds?.[0];
		const selectedLocation =
			selectedLocationId != null
				? selectedChoice.locations.find((location) => location.id === selectedLocationId)
				: undefined;
		return selectedLocation?.registrationInstructions?.trim()
			? selectedLocation.registrationInstructions
			: undefined;
	}

	return selectedChoice.instructions.registrationInstructions?.trim()
		? selectedChoice.instructions.registrationInstructions
		: undefined;
};
